import React, { useState, useMemo } from 'react';
import MUIDataTable from 'mui-datatables';

import CustomToolbar from 'components/CustomToolbar/CustomToolbar';

const VendorsTable = (props) => {
  
  const [rowsSelected, setRowsSelected] = useState([]);

  const tableData = useMemo(() => {
    const initialTableData = [];

    for ( let i = 0; i < props.vendors.length; i++ ) {
      const vendor = props.vendors[i];
      initialTableData.push({
        id: vendor.id,
        displayId: vendor.displayId,
        name: vendor.name,
        phone: vendor.phone,
        trn: vendor.trn,
        payableAmount: vendor.payableAmount
      });
    }

    return initialTableData;
    
  }, [props.vendors]);

  const columns = [
    { label: "ID", name: "displayId"},
    { label: "Name", name: "name"},
    { label: "Phone", name: "phone" },
    { label: "TRN Number", name: "trn" },
    {
      label: "Payable Amount",
      name: "payableAmount",
      options: {
        filter: true,
        sort: true,
        viewColumns: false,
        customBodyRender: (value, tableMeta) => (
          <font color={ value < 0 ? "red" : null }>{value}</font>
        )
      }
    },
  ];

  const onRowSelectionChange = (curr, all, rowsSelected) => {
    setRowsSelected(rowsSelected);
    if(rowsSelected.length === 1) {
      const vendorInfo = props.vendors[rowsSelected[0]];
      props.setUpdateInfo({
        id: vendorInfo.id,
        name: vendorInfo.name,
        phone: vendorInfo.phone,
        trn: vendorInfo.trn
      });
    }
  };

  const customToolbarSelect = () => {
    return(
      <CustomToolbar
        switchy={3}
        element="Vendor"
        setUpdate={props.updateVendor}
      />
    )
  };

  const options = {
    filterType: 'checkbox',
    onRowSelectionChange,
    selectableRows: "single",
    selectableRowsOnClick: true,
    customToolbarSelect,
    rowsSelected
  };

  return (
    <MUIDataTable 
      title={"Vendor List"}
      data={tableData}
      columns={columns}
      options={options}
    />
  )
};

export default VendorsTable;